module.exports = __webpack_public_path__ + "face_1.3de0e01d.png";